import React from 'react';
import { Router } from '@uhg-abyss/web/ui/Router';
import { MemberProfile } from '@src/common/MemberProfile/MemberProfile';
import { MemberLookup } from '../common/MemberLookup';
import { IdentifiedNeeds } from '../common/IdentifiedNeeds';
import { AppBody } from '../common/AppBody';
import { Login } from './LoginCallback/login';
import { LoginCallBack } from './LoginCallback/loginCallback';
import { PrivateRoutes } from './PrivateRoutes';
import { Redirect } from './RedirectComponent/redirect';
import { Load } from './LoadComponent/load';
import { Benefit } from './Benefit/Benefit';
import { Details } from './Details/Details';
import { Forbidden } from './Forbidden/forbidden';
import { LogOut } from './LogOut/LogOut';
import { BenefitDetails } from './Benefit/BenefitDetails';
import { BenefitSearchPage } from './Benefit/BenefitSearchPage';
import { MyFavorites } from '@src/common/MyFavorites/MyFavorites';
import { SearchImproved } from './SearchImproved/SearchImproved';
import { SdohScreenerQuestions } from '@src/common/SdohScreenerQuestions';
export const Routes = () => {
  return (
    <Router.Routes title="{{title}} | UHC Community Connector">
      <Router.Route path="/login" element={<Login />} />
      <Router.Route
        path="/callback/:request_token"
        element={<LoginCallBack />}
      />
      <Router.Route path="/load/:session" element={<Load />} />
      <Router.Route path="/load/:session/:mode" element={<Load />} />
      <Router.Route path="/logout" element={<LogOut />} />
      <Router.Route path="/error" element={<Forbidden />} />
      <Router.Route element={<PrivateRoutes />}>
        <Router.Route element={<AppBody />}>
          <Router.Route path="/question" element={<SdohScreenerQuestions />} />
          <Router.Route path="/home" element={<MemberLookup />} />
          <Router.Route
            path="/identified-needs/:id"
            element={<IdentifiedNeeds />}
          />
          <Router.Route path="/redirect" element={<Redirect />} />
          <Router.Route path="/memberprofile" element={<MemberProfile />} />
          <Router.Route path="/search" element={<SearchImproved />} />
          <Router.Route path="/planbenefits" element={<Benefit />} />
          <Router.Route
            path="/benefitdetails/:benefitId"
            element={<BenefitDetails />}
          />
          <Router.Route path="/details" element={<Details />} />
          <Router.Route
            path="/benefitsearchpage"
            element={<BenefitSearchPage />}
          />
          {/* Routes which support UniteUs */}
          {/* {featureFlagsFromStorage?.agent_uniteus_api?.enabled === false && (
            <React.Fragment>
              <Router.Route
                path="/fhir/oauth2/authorize"
                element={<FhirAuthorize />}
              />
              <Router.Route path="/uniteus" element={<UniteUs />} />
            </React.Fragment>
          )} */}

          <Router.Route path="/my-favorites" element={<MyFavorites />} />
          <Router.Route path="/*" element={<Redirect />} />
        </Router.Route>
      </Router.Route>
    </Router.Routes>
  );
};
